<nav class="fixed top-0 left-0 right-0 z-50 h-14 bg-white/95 backdrop-blur border-b border-maersk-border flex items-center px-4">
  <!-- Left: navigation toggle + logo -->
  <div class="flex items-center gap-3">
    @if (isAuthenticated) {
      <button
        type="button"
        class="ops-btn ops-btn-secondary ops-btn--icon"
        aria-label="Toggle navigation"
        [attr.title]="sidebarCollapsed ? 'Expand navigation' : 'Collapse navigation'"
        (click)="toggleSidebar.emit()">
        <i class="fas fa-bars text-sm"></i>
      </button>
    }

    <a routerLink="/dashboard" class="flex items-center gap-2 no-underline hover:no-underline">
      <span class="w-8 h-8 rounded-lg bg-maersk-navy flex items-center justify-center shadow-sm">
        <i class="fas fa-ship text-white text-xs"></i>
      </span>
      <span class="text-maersk-navy font-semibold text-lg hidden sm:inline">Support Hub</span>
    </a>
  </div>

  <!-- Center: breadcrumb -->
  @if (breadcrumb) {
    <div class="hidden sm:flex items-center ml-6 text-sm text-maersk-text-secondary">
      <i class="fas fa-chevron-right text-xs mx-2 text-maersk-text-muted"></i>
      <span class="text-maersk-text font-medium">{{ breadcrumb }}</span>
    </div>
  }

  <!-- Right: user area -->
  <div class="ml-auto flex items-center gap-2">
    @if (isAuthenticated && msal.refreshingAccessToken()) {
      <span
        class="hidden sm:inline-flex items-center gap-1.5 text-xs text-maersk-text-muted"
        role="status"
        aria-live="polite">
        <i class="fas fa-spinner fa-spin text-xs text-maersk-blue"></i>
        Refreshing session...
      </span>
    }

    @if (isAuthenticated) {
      <div class="hidden lg:flex items-center gap-2 border-r border-maersk-border pr-3 mr-1">
        <span class="inline-flex items-center rounded-md border border-red-200 bg-red-50 px-2.5 py-1 text-xs font-bold text-maersk-error">
          {{ envName }}
        </span>
        @if (tenantName()) {
          <span class="inline-flex items-center gap-1.5 rounded-md border border-maersk-border bg-white px-2.5 py-1 text-xs text-maersk-text-secondary">
            <i class="fas fa-anchor text-xs text-maersk-blue"></i>
            {{ tenantName() }}
          </span>
        }
        <span class="inline-flex items-center gap-1.5 text-xs text-maersk-text-muted">
          <i class="far fa-clock text-xs"></i>
          {{ utcTime() }}
        </span>
      </div>
    }

    @if (isAuthenticated) {
      <app-ops-notices />
    }

    @if (userName) {
      <div #userMenu class="relative">
        <button
          class="flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-maersk-bg-alt transition-colors"
          (click)="toggleMenu()">
          <span class="w-8 h-8 rounded-full bg-maersk-blue text-white text-xs font-semibold flex items-center justify-center">
            {{ userInitials }}
          </span>
          <span class="hidden sm:inline text-sm text-maersk-text font-medium">{{ userName }}</span>
          <i class="fas fa-chevron-down text-xs text-maersk-text-muted"></i>
        </button>

        @if (menuOpen) {
          <div class="absolute right-0 mt-1 w-52 bg-white rounded-lg shadow-lg border border-maersk-border py-1 z-50">
            <div class="px-4 py-2 border-b border-maersk-border">
              <div class="text-sm font-medium text-maersk-text">{{ userName }}</div>
            </div>
            @if (isAuthenticated) {
              <a
                routerLink="/account"
                class="flex items-center gap-2 px-4 py-2 text-sm text-maersk-text hover:bg-maersk-bg-alt no-underline"
                (click)="menuOpen = false">
                <i class="fas fa-user-cog w-4 text-center text-maersk-text-muted"></i> Account
              </a>
              <a
                routerLink="/config"
                class="flex items-center gap-2 px-4 py-2 text-sm text-maersk-text hover:bg-maersk-bg-alt no-underline"
                (click)="menuOpen = false">
                <i class="fas fa-cog w-4 text-center text-maersk-text-muted"></i> Config
              </a>
              <div class="border-t border-maersk-border my-1"></div>
              <button
                class="flex items-center gap-2 w-full text-left px-4 py-2 text-sm text-maersk-error hover:bg-red-50"
                (click)="menuOpen = false; onSignOut.emit()">
                <i class="fas fa-sign-out-alt w-4 text-center"></i> Sign out
              </button>
            }
          </div>
        }
      </div>
    } @else {
      <button
        class="ops-btn ops-btn-secondary"
        (click)="onSignIn.emit()">
        <i class="fas fa-sign-in-alt"></i> Sign in
      </button>
    }
  </div>
</nav>
